import React from 'react';
import FavoriteIcon from '../../components/FavoriteIcon';
import Tooltip from '../../components/Tooltip';
import { useFavoritePost } from '../useFavoritePosts';
import PostActionButton from './PostActionButton';

interface PostFavoriteButtonProps {
  postId: string;
}

const PostFavoriteButton = ({ postId }: PostFavoriteButtonProps) => {
  const { isFavorite, toggleFavorite } = useFavoritePost(postId);

  const tooltip = isFavorite ? 'Unfavorite' : 'Favorite';

  return (
    <Tooltip
      tooltip={tooltip}
      placement="left"
      trigger="hover"
      popOverPortal={document.body}
    >
      <PostActionButton onClick={() => toggleFavorite()} aria-label={tooltip}>
        <FavoriteIcon active={isFavorite} size="large" />
      </PostActionButton>
    </Tooltip>
  );
};

export default PostFavoriteButton;
